import { Box, TextField } from "@mui/material"
import type { FC } from "react"
import { useState } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { FIELD_ERROR_CLASSES, FIELD_LABEL_CLASSES, FIELD_LABEL_FONT_CLASSES } from "@/constants/forms"

interface CompanyInfoTextAreaProps {
  isEditMode: boolean
  name: string
  label?: string
  maxLength?: number
}

const CompanyInfoTextArea: FC<CompanyInfoTextAreaProps> = ({ isEditMode, name, label, maxLength }) => {
  const { control } = useFormContext()

  const [showCharacterData, setShowCharacterData] = useState<boolean>(false)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box data-testid={`company-info-form-${name}`}>
          <Box className='mb-2 flex justify-between'>
            {label && <label className={FIELD_LABEL_CLASSES}>{label}</label>}

            {maxLength && showCharacterData && (
              <p className={`ml-auto ${FIELD_LABEL_FONT_CLASSES} ${error ? "text-red-600" : "text-gray-500"}`}>
                ({field.value?.length ?? 0}/{maxLength}) Characters
              </p>
            )}
          </Box>

          <TextField
            {...field}
            name={field.name}
            placeholder={isEditMode ? "Add Info..." : "Click on Edit to add info"}
            multiline
            disabled={!isEditMode}
            rows={2}
            onBlur={() => setShowCharacterData(false)}
            onFocus={() => setShowCharacterData(true)}
            error={!!error}
            fullWidth
            variant='outlined'
            slotProps={{
              input: {
                className: `text-sm ${!isEditMode ? "bg-gray-200 text-gray-600" : "text-gray-800"}`,
              },
              htmlInput: {
                className: "focus:border-0 focus:ring-0 focus:outline-none",
              },
            }}
          />
          {error?.message && <p className={FIELD_ERROR_CLASSES}>{error.message}</p>}
        </Box>
      )}
    />
  )
}

export default CompanyInfoTextArea
